import { IPage } from 'layouts/Navbar/Navbar.types';

const pages: IPage[] = [
  { path: '/projects', label: 'Projects' },
  { path: '/blog', label: 'Blog' },
  { path: '/about', label: 'About' },
  { path: '/contact', label: 'Contact' },
];

export default pages;
